import React, { useState, useEffect } from 'react';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import { MdOutlineRefresh } from 'react-icons/md';

function RefreshButton({
    loading,
    doQuery,
    showAutoRefresh,
    autoRefresh,
    setAutoRefresh,
}) {
    return (
        <Dropdown as={ButtonGroup} className="col-sm float-end ms-2 position-relative">
            <button
                type="button"
                className="btn btn-secondary"
                onClick={doQuery}
                disabled={loading}
                data-testid="RefreshIcon"
            >
                {loading ? (
                    <div className="spinner-border spinner-border-sm" role="status" />
                ) : (
                    <MdOutlineRefresh />
                )}
            </button>

            {showAutoRefresh && (
                <>
                    <Dropdown.Toggle split variant="secondary" />
                    <Dropdown.Menu>
                        <Dropdown.Item
                            active={autoRefresh === '1'}
                            onClick={() => setAutoRefresh('1')}
                        >
                            Auto Refresh On
                        </Dropdown.Item>
                        <Dropdown.Item
                            active={autoRefresh === '0'}
                            onClick={() => setAutoRefresh('0')}
                        >
                            Auto Refresh Off
                        </Dropdown.Item>
                    </Dropdown.Menu>
                    <span
                        className={`position-absolute top-0 start-100 translate-middle p-2 border border-light rounded-circle 
                                    ${autoRefresh === '1' ? 'pulse bg-success' : 'bg-secondary'}`}
                    >
                        <span className="visually-hidden">Auto Refresh</span>
                    </span>
                </>
            )}
        </Dropdown>
    );
}

export default RefreshButton;
